var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap");

require("app/theme/IconButton--content-type.less");

module.exports = kind(/** @lends  app.ProductPage.ContentTypeMenuButton.prototype */ {

    /**
     * @private
     */
    name: "app.ProductPage.ContentTypeMenuButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-product-page-content-type-menu-button",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "content-type",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: icons["app.ProductPage.ContentTypeMenuButton"],

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "right",

    /**
     * @private
     */
    bindings: [{
        from: ".repeater.activeContentType",
        to:   ".activeContentType"
    }],

    /**
     * @private
     */
    observers: {
        update: ["activeContentType", "data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var data              = this.data || {},
            activeContentType = this.get("activeContentType") || {};

        this.set("caption", get(data, "meta.title", null) || "");
        this.set("href", get(data, "links.self", null));

        if (data.id && data.id === activeContentType.id) {
            this.addClass("active");
        }
        else {
            this.removeClass("active");
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    tap: function() {
        return onHyperlinkTap.call(this, this);
    }

});
